import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";
import Proptypes from "prop-types";
import {
  toFormattedDate,
  toHibridSocietyFormat,
  toHibridDivisionFormat
} from "../../../utils/format";

const Transfer = ({ date, accountNumber, name, society, division }) => {
  return (
    <div className="col-md-6 col-12">
      <Card className="h-100">
        <CardHeader>
          <h3>Transferencia recibida</h3>
        </CardHeader>
        <CardBody>
          <div className="row mb-2">
            <div className="col-lg-6 col-12">
              <dl>
                <dd>{toFormattedDate(date)}</dd>
                <dd className="d-flex align-items-center">
                  <span className="icono-credit-card" />
                  <span>{accountNumber}</span>
                </dd>
              </dl>
            </div>
            <div className="col-lg-6 col-12">
              <dl>
                <dt>Ordenante</dt>
                <dd>{name}</dd>
              </dl>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-lg-12">
              <dl>
                <dt>Sociedad</dt>
                <dd>{toHibridSocietyFormat(society)}</dd>
                <dt>División</dt>
                <dd>{toHibridDivisionFormat(division)}</dd>
              </dl>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

Transfer.propTypes = {
  date: Proptypes.string,
  accountNumber: Proptypes.string,
  name: Proptypes.string,
  society: Proptypes.string,
  division: Proptypes.string
};

Transfer.defaultProps = {
  date: "",
  accountNumber: "",
  name: "",
  society: "",
  division: ""
};

export default Transfer;
